import { useSentryAsync } from '@/shared/composition/useSentryAsync';

const { captureExceptionSentry } = useSentryAsync();

export const commonSentryCaptureException = captureExceptionSentry;
